import request from '@/config/axios'

export const getTagLib = () => request.get({ url: '/bosscircle/tag-lib/get' })

export const updateTagLib = (data: { group: string; tags: string[] }) =>
  request.put({ url: '/bosscircle/tag-lib/update', data })
